import L from "leaflet";
import { zoneOverlays } from "../../../../util/zoneOverlays";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { readStoredMapData } from "./openMapTab";
import { useParams } from "react-router-dom";
import * as actions from "../actions";
// import axios from "axios"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import fleetIcon from "../../../../assets/flaticons/cargo-ship.png";
import { toastError } from "../../../../utils";
import {
  addPortDistanceToOperations,
  convertPortOperationToDistanceString,
  getGeoJsonLineAndCoordinates,
} from "../dataMapping";
import { alignLng, geoJsonToLines, repeatOnWorldCopies, unwrapLines } from "../../../../util/worldCopies";
import "./index.css";
// https://sigmafinder.fleetsigma.com/v3/route/72.866667,18.966667/35.533333,27.566667?none=false
// windy.com

// const getLatLongAPIresponse = (lat1, long1, lat2, long2) => {
//     return new Promise((resolve, reject) => {
//         axios.get(`https://sigmafinder.fleetsigma.com/v3/route/${lat1},${long1}/${lat2},${long2}?none=false`).then(res => {
//             console.log(res``)
//             resolve(res)
//         }).catch(err => {
//             reject({})
//         })
//     })
// }

function ShowMap(props) {
  const {
    setLoader = () => { },
    setIsFullScreen,
    id,
    showSidebar = true,
    portDistanceResponse: propsPortDistanceResponse,
    portOperation: propsPortOperationRaw,
    fleetList: propsFleetListRaw,
  } = props;

  const { id: selectedQueryId = "" } = useParams();
  const stored = useMemo(
    () => (propsPortOperationRaw?.length ? null : readStoredMapData(selectedQueryId)),
    [selectedQueryId]
  );
  const portDistanceResponse = propsPortDistanceResponse || stored?.portDistanceResponse || {};
  const propsPortOperation = propsPortOperationRaw || stored?.portOperation || [];
  const propsFleetList = propsFleetListRaw || stored?.fleetList || [];
  const mapInstance = useRef(null);
  const hasFetched = useRef(null);
  const [portOperation, setPortOperation] = useState([]);
  const [fleetList, setFleetList] = useState([]);
  const [hideOrder, setHideOrder] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(20);
  const [CargoList, setCargoList] = useState([]);
  const selectedCargo = window.location.pathname;
  const [totalPages, settotalPages] = useState(0);
  const flagsvg = () => {
    return `<svg
                  width='26'
                  height='26'
                  viewBox='0 0 56 56'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M4.14845 3.11084C3.00325 3.11084 2.02558 3.51675 1.21524 4.32608C0.405344 5.13642 0 6.1142 0 7.25929C0 8.01538 0.188994 8.70688 0.567323 9.33323C0.945083 9.9598 1.44759 10.4566 2.07394 10.8241V51.8522C2.07394 52.1548 2.17099 52.4034 2.36566 52.5976C2.55999 52.7922 2.80824 52.8889 3.11108 52.8889H5.18502C5.48764 52.8889 5.73622 52.7921 5.93044 52.5976C6.12488 52.4034 6.22193 52.1548 6.22193 51.8522V10.8241C6.84851 10.4566 7.35079 9.9598 7.72878 9.33323C8.10699 8.70688 8.29587 8.01504 8.29587 7.25929C8.29587 6.11454 7.89098 5.13688 7.0812 4.32608C6.27097 3.51641 5.29319 3.11084 4.14845 3.11084Z'
                    fill='black'
                  />
                  <path d='M54.9969 7.55068C54.3268 7.16203 53.6575 7.14069 52.9866 7.48621C52.7929 7.59461 52.4576 7.77793 51.9825 8.03719C47.9209 10.4569 44.5725 11.6669 41.9364 11.6669C40.8344 11.6669 39.8725 11.4616 39.0518 11.0512C36.6326 9.86299 34.3745 8.9338 32.2788 8.26387C30.1831 7.59461 27.9254 7.25953 25.5058 7.25953C23.9287 7.25953 22.2541 7.46487 20.4827 7.87543C18.7111 8.28577 17.0634 8.82052 15.5403 9.4791C14.0173 10.1381 12.7854 10.6998 11.846 11.1644C10.9056 11.629 10.0576 12.0877 9.30178 12.5416C8.63196 12.9736 8.29688 13.5677 8.29688 14.324V38.3702C8.29688 39.1695 8.64263 39.7748 9.3339 40.185C9.67954 40.3582 10.0253 40.444 10.371 40.444C10.7597 40.444 11.1165 40.347 11.4402 40.1531C13.4926 38.9 15.9607 37.7976 18.845 36.847C21.7296 35.8965 24.2737 35.4211 26.4774 35.4211C27.73 35.4211 28.9621 35.5722 30.1718 35.8748C31.3814 36.1771 32.365 36.4909 33.1208 36.8144C33.8763 37.1387 34.9457 37.657 36.3291 38.3702L37.2365 38.8239C38.7483 39.5806 40.4551 39.9589 42.3559 39.9589C45.6188 39.9589 49.6047 38.7057 54.3146 36.1996C54.4661 36.1133 54.6494 36.0162 54.8655 35.9078C55.6214 35.519 56.0001 34.9036 56.0001 34.0608V9.33313C56.0007 8.57704 55.6657 7.98316 54.9969 7.55068ZM12.4445 15.5233C17.025 12.9737 21.1729 11.6127 24.8893 11.4399V17.824C21.2377 17.9755 17.0892 19.25 12.4445 21.6483V15.5233ZM24.8894 31.3704C21.0218 31.6727 16.8733 32.8613 12.4446 34.9356V28.9396C16.8304 26.758 20.9789 25.494 24.8894 25.1482V31.3704ZM51.852 32.8296C48.1143 34.8168 44.9492 35.8104 42.3568 35.8104C41.2987 35.8104 40.3152 35.6263 39.4078 35.2594V29.1673C42.6272 30.1395 46.775 29.3731 51.8521 26.8663V32.8296H51.852ZM51.852 18.9912C46.754 21.8428 42.6054 22.8149 39.4077 21.9081V29.1665C38.9757 29.0375 38.5545 28.8752 38.1436 28.6806C35.832 27.5355 33.6981 26.6495 31.7435 26.0229C29.7879 25.3966 27.7083 25.0831 25.5046 25.0831H24.889V17.8886C25.4505 17.8237 25.9799 17.7915 26.4767 17.7915C26.9517 17.7915 27.4275 17.8135 27.9026 17.8564C28.3781 17.8993 28.8052 17.9426 29.1828 17.9858C29.5603 18.029 29.9868 18.1097 30.4631 18.2288C30.9385 18.3473 31.3168 18.4391 31.5973 18.5039C31.8786 18.5692 32.2673 18.7041 32.7646 18.9093C33.2618 19.115 33.6122 19.2554 33.8176 19.331C34.0228 19.4066 34.3956 19.5739 34.9361 19.8332C35.4756 20.0927 35.8163 20.2548 35.9564 20.3194C36.0975 20.3842 36.4699 20.568 37.0748 20.8708C37.6797 21.173 38.0367 21.3568 38.1443 21.4217C38.5544 21.6163 38.9759 21.7785 39.4079 21.9079V15.5561C40.1211 15.7287 40.9637 15.8156 41.9356 15.8156C44.8955 15.8156 48.2013 14.8322 51.8527 12.8665V18.9913H51.852V18.9912Z'
                    fill='black'
                  />
                </svg>`;
  };
  const markersvg = (num) => {
    return `
        <svg
          width='50'
          height='50'
          viewBox='0 0 60 81'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M30.0336 80.2488C29.0354 80.2488 28.124 79.8148 27.473 79.0336C21.0496 71.0043 0 43.7918 0 29.9902C0 13.4544 13.4544 0 29.9902 0C46.5261 0 59.9804 13.4544 59.9804 29.9902C59.9804 43.8352 38.9743 71.0477 32.5075 79.0336C31.9433 79.8148 31.0318 80.2488 30.0336 80.2488ZM30.0336 6.72718C17.2303 6.72718 6.81398 17.1435 6.81398 29.9468C6.81398 42.7502 17.2303 53.1664 30.0336 53.1664C42.837 53.1664 53.2533 42.7502 53.2533 29.9468C53.2533 17.1435 42.837 6.72718 30.0336 6.72718Z'
            fill='url(#paint0_linear_1097_10904)'
          />
          <path
            d='M30.0331 49.7811C19.096 49.7811 10.2422 40.8839 10.2422 29.9902C10.2422 19.0965 19.1394 10.1992 30.0331 10.1992C40.9702 10.1992 49.8241 19.0965 49.8241 29.9902C49.8241 40.8839 40.9268 49.7811 30.0331 49.7811Z'
            fill='url(#paint1_linear_1097_10904)'
          />
          <path
            d='M30.0319 0.477051C13.7565 0.477051 0.5625 13.671 0.5625 29.9465C0.5625 43.531 21.1347 70.2662 27.9052 78.686C28.9903 80.0314 31.0735 80.0314 32.1586 78.686C38.9291 70.2662 59.5013 43.5744 59.5013 29.9465C59.5013 13.671 46.3073 0.477051 30.0319 0.477051ZM30.0319 53.7303C16.9247 53.7303 6.29146 43.097 6.29146 29.9899C6.29146 16.8827 16.9247 6.24941 30.0319 6.24941C43.1391 6.24941 53.7724 16.8827 53.7724 29.9899C53.7724 43.097 43.1391 53.7303 30.0319 53.7303Z'
            fill="#313C4C"
          />
          <path
            d='M30.0318 49.2165C40.6744 49.2165 49.302 40.589 49.302 29.9464C49.302 19.3038 40.6744 10.6763 30.0318 10.6763C19.3892 10.6763 10.7617 19.3038 10.7617 29.9464C10.7617 40.589 19.3892 49.2165 30.0318 49.2165Z'
            fill='white'
          />
    
          <text
            x=${num >= 9 ? "22" : "25"}
            y='35'
            fill='#000'
            fontWeight='600'
            textAlign='center'
            alignmentBaseline='middle'
            style="font-size: 17px;"
          >
            ${num}
          </text>
    
          <defs>
            <linearGradient
              id='paint0_linear_1097_10904'
              x1='14.139'
              y1='-7.81286'
              x2='51.6603'
              y2='79.4963'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='white' />
              <stop offset='1' stopColor='#517536' />
            </linearGradient>
            <linearGradient
              id='paint1_linear_1097_10904'
              x1='13.8377'
              y1='-7.68381'
              x2='51.359'
              y2='79.6254'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='white' />
              <stop offset='1' stopColor='#517536' />
            </linearGradient>
          </defs>
        </svg>`;
  };

  useEffect(() => {
    setIsFullScreen(true);

    return () => {
      setIsFullScreen(false);
    };
  }, []);

  const getInitialData = async (selectedQueryId) => {
    try {
      setLoader(true);
      let isSingleCalc = false;
      if (selectedQueryId?.startsWith("single")) {
        isSingleCalc = true;
      }
      let portOperation = [];
      let queryData = {};
      let fleetsResponse = null;

      if (propsPortOperation && propsPortOperation.length > 0) {
        portOperation = propsPortOperation;
        fleetsResponse = { data: { list: propsFleetList } };
      } else {
        const [response0, fleets] = await Promise.all([
          isSingleCalc
            ? actions.saveResultById(selectedQueryId?.split("single")?.[1])
            : actions.queryById(selectedQueryId),
          actions.allFleet(),
        ]);
        queryData = isSingleCalc ? response0.data.clientQuery : response0.data;
        portOperation = queryData?.cargoList || [];
        fleetsResponse = fleets;
      }

      const { routeList } = convertPortOperationToDistanceString({
        portOperation,
        fleetList: fleetsResponse?.data?.list || propsFleetList,
      });
      const {
        eca = false,
        hra = false,
        jwc = false,
        suez = false,
        panama = false,
        singapore = false,
      } = queryData;
      const portDataObj = {
        eca,
        hra,
        jwc,
        suez,
        panama,
        singapore,
        routeOverride: false,
        routeList: routeList,
        portList: routeList,
        clientQueryId: selectedQueryId,
        queryId: selectedQueryId,
        getGeometry: true,
      };

      let portDistanceRes = {};
      if (Object.keys(portDistanceResponse || {})?.length > 0) {
        portDistanceRes = { data: portDistanceResponse };
      } else {
        portDistanceRes = await actions.getPortDistanceByPortList(portDataObj);
      }

      const newPortOperations = addPortDistanceToOperations(
        portDistanceRes?.data,
        [...portOperation],
        {},
        true
      );

      setFleetList(fleetsResponse.data.list || []);
      setMapMarkers(newPortOperations, fleetsResponse.data.list || []);
      setLoader(false);
    } catch (ex) {
      setLoader(false);
      toastError(ex?.data?.message);
    }
  };

  const mapGeometryKey = useMemo(() => {
    const portsKey = (propsPortOperation || [])
      .map((p) => `${p.port}_${p.lat}_${p.lng}_${p.operation}`)
      .join("|");
    const distanceKey = JSON.stringify(portDistanceResponse || {});
    const fleetKey = (propsFleetList || [])
      .map((f) => `${f.port}_${f.lat}_${f.lng}`)
      .join("|");
    return `${id || selectedQueryId}_${portsKey}_${distanceKey}_${fleetKey}`;
  }, [id, selectedQueryId, propsPortOperation, portDistanceResponse, propsFleetList]);

  useEffect(() => {
    const targetId = id || selectedQueryId;
    if (targetId) {
      if (hasFetched.current === mapGeometryKey) return;
      hasFetched.current = mapGeometryKey;
      getInitialData(targetId);
    }
  }, [id, selectedQueryId, mapGeometryKey]);

  const setMapMarkers = async (newPortOperations = [], fleets = []) => {
    try {
      if (mapInstance.current) {
        mapInstance.current.off();
        mapInstance.current.remove();
      }
      const centerIndex = Math.floor(newPortOperations.length / 2);
      const centerLat =
        (newPortOperations[centerIndex] &&
          newPortOperations[centerIndex].lat) ||
        51.505;
      const centerLong =
        (newPortOperations[centerIndex] &&
          newPortOperations[centerIndex].lng) ||
        -0.09;
      const center = [centerLat, centerLong];
      var defaultZoom = 3;
      var defaultMapCenter = new L.LatLng(20, 0);
      var editableLayers = new L.FeatureGroup();

      // const map = L.map('map').setView(center, 2);

      // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      // }).addTo(map);

      var seaDefault = L.tileLayer(
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
      );
      var seaMark = new L.TileLayer(
        "http://t1.openseamap.org/seamark/{z}/{x}/{y}.png",
      );
      var seaProfil = new L.TileLayer(
        "https://server.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}",
      );
      var osm = new L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png");
      var Esri_WorldImagery = L.tileLayer(
        "http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      );
      var Esri_WorldGrayCanvas = L.tileLayer(
        "http://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
      );
      var OpenStreetMap_BlackAndWhite = L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
      );

      mapInstance.current = new L.Map("map", {
        layers: [seaDefault, seaMark],
        center: defaultMapCenter,
        zoom: defaultZoom,
        editable: true,
        minZoom: 2,
        cursor: true,
      });

      mapInstance.current.on("baselayerchange", function (event) {
        seaMark.bringToFront();
      });
      var baseMaps = {
        Default: seaDefault,
        "Sea profile": seaProfil,
        Imagery: Esri_WorldImagery,
        "Open Street Map": osm,
        Gray: Esri_WorldGrayCanvas,
        "Black & white": OpenStreetMap_BlackAndWhite,
      };
      var overlayMaps = {
        // "Show ports": getPortsLayer(),
        // "Show ECA zones": displayZones(eca_areas, 'ECA', "green"),
        // "Show HRA zonse": displayZones(hra_areas, 'HRA', "red"),
        // "Show JWC zones": displayZones(jwc_areas, 'JWC', "blue"),
        // "Show Grid": displayGrid()
      };
      L.control.layers(baseMaps, { ...overlayMaps, ...zoneOverlays(mapInstance.current) }).addTo(mapInstance.current);
      mapInstance.current.zoomControl.setPosition("topright");
      // mapInstance.current.addLayer(editableLayers);

      // L.control.mousePosition({ position: 'bottomright', numDigits: 6 }).addTo(mapInstance.current);


      // const svgFlagIcon = L.divIcon({
      //   html: flagsvg(),
      //   className: "",
      //   iconSize: [38, 38],
      //   iconAnchor: [26, 48],
      //   popupAnchor: [0, -38]
      // });
      // const startingpoint = newPortOperations.filter(
      //   (operation) => operation?.operation === "Commence"
      // );
      // L.marker([startingpoint?.[0]?.lat, startingpoint?.[0]?.lng], { icon: svgFlagIcon }).addTo(mapInstance.current);
      newPortOperations = newPortOperations.filter(
        (operation) => operation?.operation !== "Commence",
      );

      // One continuous track across the antimeridian, repeated on every world copy
      const routeLines = unwrapLines(
        geoJsonToLines(
          newPortOperations
            .filter((op) => op.geoJSON)
            .map((op) => getGeoJsonLineAndCoordinates(op.geoJSON)),
        ),
      );
      const portLngs = newPortOperations.map((op) => alignLng(op.lng, routeLines));

      const drawCopy = (offset) => {
      for (let i = 0; i < newPortOperations.length; i++) {
        const svgIcon = L.divIcon({
          html: markersvg(i + 1),
          className: "",
          iconSize: [38, 38],
          iconAnchor: [26, 48],
          popupAnchor: [0, -38],
        });
        let lat1 = newPortOperations[i].lat || 0;
        let long1 = portLngs[i] + offset;

        const popupContent = `
        <div>
            <h3 style="margin: 0 0 10px 0; font-size: 18px; font-weight: bold; color: #FFA500;">Information</h3>
            <table style="width: 100%; border-collapse: collapse;">
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Operation</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].operation || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Port:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].port || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Cargo Tx:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].cargoTx || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Rate Mt/day</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].rate || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Terms:</td>
                     <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">
                     ${newPortOperations[i].terms || 0}
                       </td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Turn Time(days):</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].turnTime || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Extra Days:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].extraDays || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Port Exp:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].portExp || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Port Stay:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].portStay || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Port Emission:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].sulfur || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Draft Restriction:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].draftRes || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Water Density:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].waterDensity || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Fuel supply:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${(newPortOperations[i]?.cargoDetails?.bunkerSuppliedHSFO + newPortOperations[i].cargoDetails.bunkerSuppliedLSFO + newPortOperations[i].cargoDetails.bunkerSuppliedMGO) | "-"}</td>
                </tr>
          
            </table>
        </div>`;

        L.marker([lat1, long1], { icon: svgIcon })
          .addTo(mapInstance.current)
          .bindPopup(popupContent);

        // .openPopup();
      }
      var myStyle = {
        color: "#313C4C",
        weight: 3,
        opacity: 1,
      };

      L.geoJSON(
        {
          type: "MultiLineString",
          coordinates: routeLines.map((line) => line.map(([x, y]) => [x + offset, y])),
        },
        { style: myStyle },
      ).addTo(mapInstance.current);
      };
      repeatOnWorldCopies(
        mapInstance.current,
        [...routeLines.flat().map(([x]) => x), ...portLngs],
        drawCopy,
      );

      var greenIcon = L.icon({
        iconUrl: fleetIcon,
        // shadowUrl: 'leaf-shadow.png',
        iconSize: [25, 25],
        iconAnchor: [10, 18],
        popupAnchor: [0, -5],
        // iconSize: [38, 95], // size of the icon
        // shadowSize:   [50, 64], // size of the shadow
        // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
        // shadowAnchor: [4, 62],  // the same for the shadow
        // popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
      });
      for (let i = 0; i < fleets.length; i++) {
        const { lat = 0, lng = 0, vessel } = fleets[i];
        const vesselData = vessel ? JSON.parse(vessel) : {};
        const popupContent = `
        <div>
            <h3 style="margin: 0 0 10px 0; font-size: 18px; font-weight: bold; color: #FFA500;">Vessel Information</h3>
            <table style="width: 100%; border-collapse: collapse;">
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Vessel Name:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${vesselData.vesselName || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Port:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${fleets[i].port || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">DWT:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${vesselData.vesselDwt || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Freight Cost:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${fleets[i].frtCost || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Date Opening:</td>
                     <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">
                      ${fleets[i].dateOpen
            ? new Date(fleets[i].dateOpen).toLocaleDateString(
              "en-GB",
              {
                day: "2-digit",
                month: "short",
                year: "numeric",
              },
            )
            : "-"
          }
                       </td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">TC Eq:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${fleets[i].tcEq || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">TC GBB:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].tcGbb || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Hire:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].hire || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Hire GBB:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${fleets[i].hireGbb || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Profit:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${fleets[i].profitNet || 0}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Loadability:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${fleets[i].loadablity || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">ETA:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${newPortOperations[i].ETA || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-weight: bold; font-size: 12px">Vessel Premium:</td>
                    <td style="padding: 4px; border-bottom: 1px solid #444; font-size: 11px">${fleets[i].vesselPremium || "-"}</td>
                </tr>
                <tr>
                    <td style="padding: 4px; font-weight: bold;">Position Premium:</td>
                    <td style="padding: 4px;">${fleets[i].positionPremium || "-"}</td>
                </tr>
            </table>
        </div>`;
        L.marker([lat, lng], { icon: greenIcon })
          .addTo(mapInstance.current)
          .bindPopup(popupContent);
      }
    } catch (ex) {
      console.log(ex.message || "Something went wrong");
    }
  };

  function displayGrid() {
    return L.latlngGraticule({
      showLabel: true,
      color: "black",
      weight: 0.3,
      zoomInterval: [
        { start: 2, end: 2, interval: 40 },
        { start: 3, end: 3, interval: 20 },
        { start: 4, end: 4, interval: 10 },
        { start: 5, end: 7, interval: 5 },
        { start: 8, end: 20, interval: 1 },
      ],
    });
  }

  function displayZones(list, name, color) {
    var newArea = [];
    var polygons = [];
    list.forEach(function (area) {
      var inversedPoly = [];
      area.polygon.forEach(function (p) {
        inversedPoly.push([p[1], p[0]]);
      });
      newArea.push({ name: area.name, polygon: inversedPoly });
      var poly = L.polygon(inversedPoly, {
        color: color,
        opacity: 0.1,
        fillColor: color,
        fillOpacity: 0.3,
      }).bindPopup(name + " : " + area.name);
      polygons.push(poly);
    });
    return L.layerGroup(polygons);
  }

  const fetchCargoData = async (page, limit) => {
    const res = await actions.getAllCargo({ limit, page });
    const data = res.data;
    setCargoList((prev) => [...prev, ...data]);
    settotalPages(data.totalPages);
  };
  useEffect(() => {
    fetchCargoData(currentPage, limit);
  }, [currentPage]);
  // Debounce function
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const handleScroll = debounce(() => {
    const bottom =
      window.innerHeight + window.scrollY >= document.body.offsetHeight;
    if (bottom && CargoList.length < totalPages) {
      // Check if more items are available
      setCurrentPage((prev) => prev + 1); // Load next page
    }
  }, 200); // Adjust the delay as needed

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [CargoList, totalPages]); // Add dependencies
  // function getPortsLayer() {
  //     var ports = [];
  //     portsList.forEach(function (p) {
  //         var cityMarker = L.circleMarker(p.latlng, {
  //             radius: 2,
  //             color: '#666',
  //             fillOpacity: 1
  //         }).on('click', function () {
  //             cityMarker.bindPopup(makePopupText(null, p.id, p.title_short, p.country_name, p.country_code, false)).openPopup();
  //         });
  //         ports.push(cityMarker)
  //     });
  //     return L.layerGroup(ports);
  // }

  return (
    <>
      <div className="flex h-screen bg-gray-50 ">
        {showSidebar && !stored && (
          <div
            className={`relative -left-6 -top-6 transition-all duration-300 ${hideOrder ? "w-0 overflow-visible border-0" : "w-[280px]"} bg-[#eef2f6] rounded-xl rounded-l-none border border-gray-400 shadow-lg`}
          >
            <button
              onClick={() => setHideOrder((prev) => !prev)}
              className="absolute right-[-2.54rem] top-14 p-3 bg-[#eef2f6] text-[#4052b6] rounded-full rounded-l-none border-l-0 hover:bg-blue-700 transition z-[50] border border-gray-400"
            >
              {hideOrder ? <FaArrowRight /> : <FaArrowLeft />}
            </button>

            <div className={`p-2  ${hideOrder ? "hidden" : "block"}`}>
              <h2 className="text-center font-semibold text-lg text-gray-800 mb-4">
                Select Cargo
              </h2>
              <div className="mt-4 flex flex-col gap-3">
                {CargoList.length ? (
                  CargoList.map((Cargo, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        window.location.href = `${window.location.origin}/map/${Cargo._id}`;
                      }}
                      className={`w-full flex items-center border ${selectedCargo === `/map/${Cargo._id}`
                        ? "border-gray-600 bg-[#e6f7ff] hover:bg-[#dfe0f8]"
                        : "border-0"
                        } justify-between px-2 py-2 text-xs font-medium text-gray-900 bg-[#e6e8ec] rounded-md  transition-all duration-300 transform hover:bg-[#cdcecf]`}
                    >
                      <span>{Cargo.name}</span>
                    </button>
                  ))
                ) : (
                  <div className="text-center text-gray-700">
                    No Cargos found.
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="showmap-container z-30 " id="map" />
      </div>
    </>
  );
}

export default memo(ShowMap);
